import { cn } from "@dune/ui";

export const Page = ({
	children,
	withBackground = false,
}: {
	children: React.ReactNode;
	withBackground?: boolean;
}) => {
	return (
		<div
			className={cn(
				"w-full max-w-full overflow-x-hidden h-full flex flex-col box-border",
				{
					"rounded-tl-lg border bg-background p-6": withBackground,
				},
			)}
		>
			{children}
		</div>
	);
};
